module.exports = __webpack_public_path__ + "img/SEJ enventos_id.baa1af79.svg";